import { FiCalendar } from "react-icons/fi";
import "../../../assests/css/studentdashboard/StudentDashboard.css";
import DashBoardActivity from "../../../components/studentdashboardcard/DashBoardActivity";
import StudentDashboardCard from "../../../components/studentdashboardcard/StudentDashboardCard";
import StudentsideLayout from "../../../layouts/StudentsideLayout";
import { useContext, useEffect } from "react";
import { useState } from "react";
import { AppContext } from "../../../context/Appcontext";
import axios from "axios";
import { Building2, BookOpen, FileText, Layers } from "lucide-react";

const StudentDashboard = () => {
  const { baseUrl, authToken } = useContext(AppContext);
  const loggedInStudent = JSON.parse(localStorage.getItem("student"));

  const [dashboard, setDashboard] = useState({
    program: "",
    semester: "",
    courses: 0,
   
  });

  // ===== Courses state (same logic as TeacherCourses) =====
  const [activeCourse, setActiveCourse] = useState(null);
  const [studentCourses, setStudentCourses] = useState([]);
  const [coursesLoading, setCoursesLoading] = useState(true);

  const handleDetailsClick = (id) => {
    setActiveCourse((prev) => (prev === id ? null : id));
  };

  const stats = [
    {
      title: "Program",
      value: dashboard.program,
      icon: Building2,
      color: "#3B82F6",
    },
    {
      title: "Semester",
      value: dashboard.semester,
      icon: Layers,
      color: "#8B5CF6",
    },
    {
      title: "Courses",
      value: studentCourses.length,
      icon: BookOpen,
      color: "#10B981",
    },
  
  ];

  const getDashboardStats = () => {
    if (!loggedInStudent) {
      console.log("Student data not found in localStorage");
      return;
    }

    axios
      .get(`${baseUrl}/student/dashboard/studentDashboard`, {
        params: {
          ngstudent_id: loggedInStudent.id,
        },
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((response) => {
        setDashboard({
          program: response.data.program,
          semester: response.data.semester,
          courses: response.data.courses,
         
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // ===== Same logic as TeacherCourses -> viewAllTeacherCourse =====
  const viewAllStudentCourse = () => {
    setCoursesLoading(true);
    const formData = new FormData();
    formData.append("ngstudent_id", loggedInStudent?.id);

    axios
      .post(`${baseUrl}/student/course/viewAllStudentCourse`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((response) => {
        console.log(response.data);
        if (response.data.success == true) {
          setStudentCourses(response.data.courses);
        }
        setCoursesLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setCoursesLoading(false);
      });
  };

  useEffect(() => {
    getDashboardStats();
    viewAllStudentCourse();
  }, []);

  return (
    <StudentsideLayout>
      <div className="db-wrapper">
        <div className="db-container">
          {/* Header Section */}
          <div className="db-row db-header-row">
            <div className="db-col-12">
              <h1 className="db-heading">Welcome back, Dear Student!</h1>
              <p className="db-subheading">
                You have 3 assignments due this week. Stay focused!
              </p>
            </div>
          </div>

          {/* Stats Cards */}
          {stats.map((item, index) => (
            <StudentDashboardCard
              key={index}
              title={item.title}
              value={item.value}
              icon={item.icon}
              color={item.color}
            />
          ))}

          {/* Main Content Row */}
          <div className="db-row db-content-row">
            {/* ===== Courses Section ===== */}
            <div className="db-col-12 db-col-lg-8">
              <div className="db-courses-card">
                <div className="db-courses-card-header">
                  <div>
                    <h2 className="db-courses-heading">My Courses</h2>
                    <p className="db-courses-subtext">
                      Courses assigned to you this semester
                    </p>
                  </div>

                  {!coursesLoading && studentCourses.length > 0 && (
                    <span className="db-courses-count-badge">
                      {studentCourses.length}{" "}
                      {studentCourses.length === 1 ? "Course" : "Courses"}
                    </span>
                  )}
                </div>

                {coursesLoading ? (
                  <p className="db-loading-text">Loading courses...</p>
                ) : studentCourses.length > 0 ? (
                  <div className="db-courses-grid">
                    {studentCourses.map((course) => (
                      <div className="db-course-card" key={course.id}>
                        <div className="db-course-top">
                          <span className="db-course-code">
                            {course.code || "N/A"}
                          </span>
                          <span className="db-course-status">
                            {course.status || "Active"}
                          </span>
                        </div>

                        <h4 className="db-course-title">
                          {course.ngcourse?.name ||
                            course.name ||
                            course.title ||
                            "—"}
                        </h4>

                        <div className="db-course-meta-row">
                          <span className="db-course-students-icon">👥</span>
                          <span className="db-course-students">
                            {course.students || 0} Students
                          </span>
                        </div>

                        {/* <div className="db-course-actions">
                          <button
                            className="db-btn-outline"
                            onClick={() => handleDetailsClick(course.id)}
                          >
                            {activeCourse === course.id
                              ? "Hide Details"
                              : "View Details"}
                          </button>
                        </div> */}

                        {activeCourse === course.id && (
                          <div className="db-course-outline-full">
                            <h5>
                              {course.ngcourse?.name ||
                                course.name ||
                                course.title}{" "}
                              - Course Outline
                            </h5>
                            {/* <ul>
                              {course.outline && course.outline.length > 0 ? (
                                course.outline.map((topic, idx) => (
                                  <li key={idx}>{topic}</li>
                                ))
                              ) : (
                                <li>No outline available</li>
                              )}
                            </ul>
                            <p className="db-outline-note">
                              Click Details again to collapse.
                            </p> */}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="db-no-courses-text">No courses found</p>
                )}
              </div>
            </div>

            {/* Right Sidebar */}
            <div className="db-col-12 db-col-lg-4"></div>
          </div>
        </div>
      </div>
    </StudentsideLayout>
  );
};

export default StudentDashboard;